import { ApiModel } from './generic-state.model';

export interface PaymentsCardResponseModel {
  description: string;
  discountApplied: boolean;
  guardianId: string;
  id: string;
  iframe: string;
  paymentDate: string;
  paymentMethodId: string;
  paymentTypeId: 0;
  processors: Array<{
    createdAt: string;
    id: string;
    name: 'Kushki' | 'Memphis';
    updatedAt: string;
  }>;
  reference: string;
  status: string;
  totalPaid: string;
  transactionId: string;
}

export interface PaymentCardModel {
  collection_notice_id: string | string[];
  cvv?: string;
  deferred: boolean;
  description?: string;
  discount_applied?: boolean;
  email?: string;
  first_token?: string;
  id?: string;
  is_discount_applied?: boolean;
  last_name?: string;
  months?: number;
  name?: string;
  payment_method_id?: string;
  payment_type_id?: number;
  store_code?: string;
  total_paid?: number;
  amount?: number;
}

export interface AbandonedPaymentModel extends ApiModel {
  tpvSchoolId: string;
  school: string;
  paymentDate: string;
  externalCompletedAt: string;
  reference: string;
  tpvAuthorization: string;
  transactionId: string;
  status: string;
  totalPaid: number;
  externalTransferProcessor: string;
  businessName: string;
  collectionNoticeId: string;
  tpvTransactionId: string;
  rejectedReason: string;
  tpvSchoolName: string;
  currency: string;
}

export enum FixPaymentsReasons {
  TPV_ERROR = 'tpv_error',
  GROUPED_PAYMENT = 'grouped_payment',
  TPV_CANCELLATION = 'TPV Cancel',
  EXTERNAL_PAYMENT = 'External',
  COLLECTION_ADJUST = 'collection_adjust',
  SPLIT_ACC = 'split_acc',
}

export interface FixAbandonedPaymentModel {
  status?: string;
  date?: string;
  rejected_reason?: string;
  tpv_school_id?: string;
  text?: string;
  collectionNoticeId?: string;
  payment_id?: string;
  collection_notice_id?: string;
}

export interface IdempotencyKeyModel {
  idempotencyKey: string;
}

export enum PaymentActions {
  detail = 'detail',
  partialRefund = 'partial-refund',
  refund = 'refund',
  adjust = 'adjust',
  expire = 'expire',
  unassignTPVPayment = 'unassign-tpv-payment',
  billpocketRefund = 'billpocket-refund',
}

export enum PaymentStatus {
  paid = 'pagado',
  rejected = 'rechazado',
  refund = 'devuelto',
  pending = 'pendiente',
  chargeback = 'contracargo',
}
export enum PaymentMethodsEnum {
  TPV = 'tpv',
  reference = 'referencia',
  tc_td = 'tc/td',
  SPEI = 'spei',
  CIE = 'cie',
}
